module.exports = __webpack_public_path__ + "static/media/1.3d61f47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/1.png
// module id = 1382
// module chunks = 0